import { useCallback, useEffect, useRef, useState } from 'react';

import { IconExchange, IconPhoneFilled } from '@iwoca/icons';
import { useLocation } from 'react-router';

import { DropdownMenu } from './components/DropdownMenu';
import { HamburgerIcon } from './components/HamburgerIcon';
import { HelpModal } from './components/HelpModal';
import { useGetNavigationData } from './useGetNavigationData';
import iwocaPayLogoSVG from '../../../../components/svg/iwocaPayLogo.svg';

export const BuyerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const { navItems, isSeller } = useGetNavigationData();

  const handleClickOutside = useCallback(
    (e: MouseEvent) => {
      if (
        menuRef.current !== null &&
        e.target !== null &&
        !menuRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    },
    [menuRef],
  );

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [handleClickOutside]);

  useEffect(() => {
    setIsOpen(false);
  }, [location.key]);

  const handleHelpClick = () => {
    setIsOpen(false);
    setIsHelpModalOpen(true);
  };

  return (
    <>
      <div className="fixed left-0 top-0 z-50 w-full border-b border-structure-95 bg-white text-m font-med">
        <nav className="relative h-[72px] w-full content-center justify-items-center px-xl">
          <div className="flex w-full max-w-[1500px] items-center justify-between">
            <div className="flex h-full items-center gap-l">
              <img
                src={iwocaPayLogoSVG}
                alt="iwocaPay Logo"
                className="mr-m h-full cursor-pointer"
              />
              <div className="flex gap-l m:hidden">
                {navItems.map(({ label, href }) => (
                  <a
                    key={href}
                    href={href}
                    className={`decoration-2 ${
                      location.pathname.startsWith(href) && href !== '/'
                        ? 'text-black underline'
                        : 'text-black no-underline hover:underline'
                    }`}
                  >
                    {label}
                  </a>
                ))}
              </div>
            </div>

            <div className="flex h-full items-center gap-l">
              {isSeller && (
                <a
                  href="/pay/activation/"
                  className="flex items-center gap-xs text-black no-underline decoration-2 hover:underline"
                >
                  Seller dashboard
                  <IconExchange className="h-[18px] w-[18px]" />
                </a>
              )}
              <button
                className="flex cursor-pointer items-center gap-xs border-none bg-transparent bg-none text-m no-underline"
                onClick={handleHelpClick}
              >
                Help
                <IconPhoneFilled className="h-[18px] w-[18px] fill-[#fb534a]" />
              </button>

              <div className="relative z-[1] h-full" ref={menuRef}>
                <button
                  data-testid="dropdown-menu-toggle"
                  aria-expanded={isOpen}
                  className="flex h-full cursor-pointer items-center gap-xs border-none bg-transparent bg-none px-0 py-0 text-m outline-none"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  Menu
                  <HamburgerIcon isOpen={isOpen} />
                </button>
                <DropdownMenu isOpen={isOpen} navItems={navItems} />
              </div>
            </div>
          </div>
        </nav>
      </div>
      <HelpModal
        isOpen={isHelpModalOpen}
        onClose={() => setIsHelpModalOpen(false)}
      />
    </>
  );
};
